import React, { useEffect } from "react";
import NavigateBanner from "../../common/navigate-banner";
import DentalService from "../../common/dental-service";

function Service() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <section>
        <NavigateBanner navigatePage={"Dịch vụ"} />
      </section>

      <section>
        <DentalService isServicePage={true} />
      </section>
    </main>
  );
}

export default Service;
